import React, {Component} from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, LabelList, Cell,
} from 'recharts';
import _ from 'lodash';
import {getNumericValue} from '../../../../../common/util/fieldsValidation';

class BarChartInSalesByAgencies extends Component {
  getDataKey() {
    const {data} = this.props;
    const firstElement = data.length ? data[0] : [];
    const hasAliasName = firstElement.hasOwnProperty('aliasName') ?
      'aliasName' :
      'name';
    return hasAliasName;
  }

  formatValue(value) {
    const valueFormmated = getNumericValue(value, 2);
    return `$${valueFormmated}`;
  }

  renderTooltip(totalAmount, {active, payload, label}) {
    if (!active) {
      return null;
    }

    const amount = payload[0].value;
    const percentage = (amount * 100) / totalAmount;

    return (
      <div className='sales-tooltip'>
        <p>{label}</p>
        <p>
          Ventas: {'$'}
          {getNumericValue(amount, 2)}
        </p>
        <p>Porcentaje: {getNumericValue(percentage, 0)}%</p>
      </div>
    );
  }

  changeBarColor() {
    const {data} = this.props;
    return data.map((entry, index) => (
      <Cell key={`cell-${index}`} fill={entry.color} />
    ));
  }

  render() {
    const {data} = this.props;
    const totalAmount = _.sumBy(data, 'amount');
    const dataKey = this.getDataKey();

    return (
      <ResponsiveContainer width='100%' height={500}>
        <BarChart
          data={data}
          margin={{'top': 15, 'right': 5, 'left': 20, 'bottom': 5}}
        >
          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey={dataKey} />
          <YAxis />

          <Tooltip content={this.renderTooltip.bind(this, totalAmount)} />
          <Legend />
          <Bar dataKey='amount' fill='#FFF' name='Ventas'>
            {this.changeBarColor()}
            <LabelList
              dataKey='amount'
              position='top'
              formatter={this.formatValue}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default BarChartInSalesByAgencies;
